import { gql } from "lib/apolloClient";

export const initiateTemporalWorkflowMutation = gql`
  mutation initiateTemporalWorkflow($input: InitiateTemporalWorkflowInput!) {
    integration {
      initiateTemporalWorkflow(input: $input) {
        isSuccess
        message
      }
    }
  }
`;

export const retryTemporalWorkflowMutation = gql`
  mutation retryTemporalWorkflow($input: RetryTemporalWorkflowInput!) {
    integration {
      retryTemporalWorkflow(input: $input) {
        isSuccess
        message
        dependantEntities {
          isSuccess
          dependantEntityId
          dependantEntityName
          dependantEntityType
          message
        }
      }
    }
  }
`;
